export default __webpack_public_path__ + "assets/models/c85428da164d3c24e0ce0698e460824b.glb";